// extracted by mini-css-extract-plugin
module.exports = {"root":"Confirm_root__hNzhR","btn":"Confirm_btn__vx8Tr"};